export default class Address {
    addressLine1: string = '';
    addressLine2: string;
    city: string = '';
    county: string;
    country: string = '';
    postCode: string = '';
    type: string = '';
    fromDate: Date = new Date();
    toDate: Date = new Date();
}